<form [formGroup]="filesToClassifyForm" class="form-container">
    <ng-container formArrayName="files" *ngFor="let file of filesToClassify; let i=index;">

        <ng-container *ngIf="currentStep === i">
            <div [formGroupName]="i">
                <p class="my-2"><strong>{{ 'TDFC_FILENAME' | translate }}</strong> {{file.name}}</p>

                <p-dropdown appendTo="body" [options]="fileTypes"
                    placeholder="{{ 'TDFC_SELECT_TYPE_SCAN' | translate }}" formControlName="type" optionLabel="name"
                    optionValue="value" (onChange)="onFileTypeChanged($event, i)">
                    <ng-template pTemplate="selectedItem" let-selectedOption>
                        <div>{{ selectedOption.name | translate }}</div>
                    </ng-template>
                    <ng-template pTemplate="item" let-item>
                        <div>{{ item.name | translate }}</div>
                    </ng-template>
                </p-dropdown>

                <div class="d-flex flex-wrap gap-3 my-2" style="margin-top: 15px; gap: 10px;"
                    *ngIf="requiresLeftAndRight(i)">

                    <div class="d-flex align-items-center">
                        <p-radioButton value="left" formControlName="side" inputId="left"></p-radioButton>
                        <label for="left" class="m-2 mb-0">{{ 'TDFC_LEFT' | translate }}</label>
                    </div>

                    <div class="d-flex align-items-center">
                        <p-radioButton value="right" formControlName="side" inputId="right"></p-radioButton>
                        <label for="right" class="m-2 mb-0">{{ 'TDFC_RIGHT' | translate }}</label>
                    </div>
                </div>
            </div>

            <div class="btn-container text-end mt-3">
                <button *ngIf="currentStep === 0" mat-raised-button color="accent" class="btn btn-block"
                    (click)="resetForm()">{{ 'CANCEL'
                    |
                    translate }}</button>
                <button *ngIf="currentStep > 0" mat-raised-button color="accent" class="btn btn-block"
                    (click)="currentStep = currentStep - 1">{{
                    'BACK' | translate }}</button>
                <button *ngIf="currentStep < filesToClassify.length - 1" mat-raised-button color="primary"
                    class="btn btn-block" (click)="currentStep = currentStep + 1" [disabled]="isInvalid(i)">{{
                    'NEXT' | translate
                    }}</button>
                <button *ngIf="currentStep === filesToClassify.length - 1" mat-raised-button color="primary"
                    class="btn btn-block" (click)="submitForm()" [disabled]="isInvalid(i)">{{ 'SUBMIT' |
                    translate
                    }}</button>
            </div>
        </ng-container>

    </ng-container>
</form>